module.exports = __webpack_public_path__ + "img/etc.809f87b7.svg";